import React, { useEffect, useState } from "react";
import { Table, Input, Card } from "antd";
import Service from "../../service";
import "./reward.css";
import "./karma.css";
import NodataFoundIcon from "../../assets/images/NodataFoundIcon";
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from "../../constants/tablePagination";
import EmpNameCodeCell from "../common/EmpNameCodeCell";

const KarmaSummery = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 0,
  });

  useEffect(() => {
    fetchData({ search: "", pagination });
  }, []);

  const fetchData = async ({ search = "", pagination }) => {
    setLoading(true);
    try {
      const payload = {
        search,
        pageNum: pagination.current,
        pageLimit: pagination.pageSize
      };

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.getKarmaDetails,
        body: payload
      });

      const result = response.data || { data: [], metaData: {} };

      setData(result.data);
      setPagination({
        ...pagination,
        total: result.metaData?.totalFilteredCount || 0,
      });
    } catch (err) {
      console.error("Failed to fetch data:", err);
    }
    setLoading(false);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    fetchData({ search: value, pagination: { ...pagination, current: 1 } });
  };

  const handleTableChange = (pag) => {
    fetchData({ search, pagination: pag });
  };

  const columns = [
    {
      title: "Employee",
      dataIndex: "full_name",
      key: "full_name",
      render: (text, record) => (
        <EmpNameCodeCell name={record.full_name} code={record.emp_code} />
      ),
    },
    {
      title: "Remaining Waffle",
      dataIndex: "karma_balance",
      key: "karma_balance",
      render: (value) => {
        if (value == 0 || !value) return "0";
        if (value === -1) return "Unlimited";
        return value;
      }
    },
    {
      title: "Received Waffle",
      dataIndex: "total_received_karma",
      key: "total_received_karma",
      render: (value) => {
        if (value == 0) return "0";
        return value;
      }
    },
    {
      title: "Monthly Waffle",
      dataIndex: "karma_sending_balance",
      key: "karma_sending_balance",
      render: (value) => {
        if (value == 0 || !value) return "0";
        if (value === -1) return "Unlimited";
        return value;
      }
    }
  ];

  return (
    <Card className="employee-card">
      <div className=" inout-header text-left">
        <h2> Employee Waffle Balance Dashboard</h2>
      </div>
      <div className="waffle-dashboard">
        <Card className="main-content-wrapper" >

          <div className="search-wrapper">
            <Input.Search
              placeholder="Search by Emp. Name"
              value={ search }
              onChange={ handleSearch }
              enterButton
              style={ { width: 300, marginBottom: 16 } }
            />
          </div>
          <div className='main-table-wrapper'>

            <Table
              locale={ { emptyText: <NodataFoundIcon/> } }
              columns={ columns }
              dataSource={ data }
              loading={ loading }
              rowKey="_id"
              pagination={ { ...TABLE_PAGINATION, ...pagination } }
              footer={ () => `Total employee ${pagination?.total}` }
              onChange={ handleTableChange }
              bordered
            />
          </div>
        </Card>
      </div>
    </Card>
  );
};

export default KarmaSummery;
